import { ApckAccordion } from '../common/accordion';
import { ApckLogConsole } from '../common/log_console';
import { ApckPlaceholder } from '../common/placeholder';
import { ApckProgressBar } from '../common/progress_bar';
import { ApckPropertyTable } from '../common/property_table';
import { ApckWizard, ApckWizardPane } from '../wizard/wizard';
import { ApckGoScriptScope } from './goscript_scope';
import { ApckGoScriptNetworkCredentials, ApckGoScriptVariables } from './goscript_credentials';

export const GoScriptWizardModal = {
    components: {
        'apck-goscript-scope': ApckGoScriptScope,
        'apck-wizard': ApckWizard,
        'apck-wizard-pane': ApckWizardPane,
        'apck-property-table': ApckPropertyTable,
        'apck-log-console': ApckLogConsole,
        'apck-placeholder': ApckPlaceholder,
        'apck-progress-bar': ApckProgressBar,
        'apck-accordion': ApckAccordion,
        'apck-goscript-variables': ApckGoScriptVariables,
        'apck-goscript-network-credentials': ApckGoScriptNetworkCredentials,
    },
    props: {
        activeScript: {
            type: Object,
            require: true,
        },
        events: {
            type: Array,
            default: [],
        },
        running: {
            type: Boolean,
            default: false,
        },
        wizardStatus: {
            type: Object,
            require: true,
        },
        exchange: {
            type: String,
            default: '',
        },
        exchanges: {
            type: Array,
            default: function () {
                return [];
            },
        },
        protectedKeys: {
            type: Array,
        },
    },
    data() {
        return {};
    },
    computed: {
        isWizardDisabled() {
            return this.wizardStatus.running;
        },
        isAnalyseSuccess() {
            return (
                this.wizardStatus.analyse &&
                !this.wizardStatus.analyseName.includes('Auth Mechanism NOT DETERMINED')
            );
        },
        isAnalyseWarning() {
            return (
                this.wizardStatus.analyse &&
                this.wizardStatus.analyseName.includes('Auth Mechanism NOT DETERMINED')
            );
        },
        isAnalyseFail() {
            return !this.wizardStatus.analyse;
        },
        styleAnalyse() {
            if (this.isAnalyseWarning) return 'text-warning';
            if (this.isAnalyseSuccess) return 'text-positive';
            if (this.isAnalyseFail) return 'text-negative';
        },
        enableCredentialService: function() {
            if (this.$permissions?.enable_credential_service) return true;
            return false;
        },
    },
    methods: {
        handleTabClick: function (new_index, step_index, callback) {
            if (this.wizardStatus.running) {
                this.$dialog.alert(this.wizardStatus.runningName, 'Validation Error');
                callback(null, false);
                return;
            }

            callback(null, true);
        },
        handlePrevStep: function (step_index, callback) {
            if (this.wizardStatus.running) {
                this.$dialog.alert(this.wizardStatus.runningName, 'Validation Error');
                callback(null, false);
                return;
            }
            callback(null, true);
        },
        stepIsCompleted: function (step_index) {},
        handleStep: function (step_index, callback) {
            const STEP_START = 0;
            const STEP_CREDENTIALS = 1;
            const STEP_GENERATE = 2;
            const STEP_TEST = 3;
            const STEP_SCOPE = 4;
            const STEP_ANALYSE = 5;
            const STEP_RESULT = 6;

            let errors = null;
            let success = true;
            let emitName = null;

            if (this.wizardStatus.running) {
                this.$dialog.alert(this.wizardStatus.runningName, 'Validation Error');
                callback(null, false);
                return;
            }

            if (step_index === STEP_CREDENTIALS) {
                if (!this.isPropertyRequired(['login_url', 'username', 'password'])) {
                    success = false;
                } else {
                    this.$emit('clear-log');
                    emitName = 'generate-script';
                    success = true;
                }
            }
            if (step_index === STEP_GENERATE) {
                if (this.wizardStatus.generate) {
                    this.$emit('clear-log');
                    emitName = 'test-script';
                } else {
                    this.$dialog.alert(
                        this.wizardStatus.generateName + ' Please verify your credentials.',
                        'Validation Error',
                    );
                    callback(null, false);
                    return;
                }
            }
            if (step_index === STEP_TEST) {
                if (!this.wizardStatus.test) {
                    this.$dialog.alert(this.wizardStatus.testName, 'Validation Error');
                    callback(null, false);
                    return;
                }
            }
            if (step_index === STEP_ANALYSE) {
                if (!this.wizardStatus.analyse) {
                    this.$dialog.alert(
                        this.wizardStatus.analyseName + ' Please verify your scope.',
                        'Validation Error',
                    );
                    callback(null, false);
                    return;
                }
            }
            if (step_index === STEP_SCOPE) {
                if (this.activeScript.scope_selected_values.length === 0) {
                    this.$dialog.alert(
                        "You haven't selected any scope hosts. Please select a scope to continue. Proceeding without selecting a scope may result in analysis failure.",
                        'Validation Error',
                    );
                    callback(null, false);
                    return;
                }
                this.$emit('clear-log');
                emitName = 'analyse-script';
            }

            // we continue to the next by default
            this.$nextTick(function () {
                if (emitName) this.$emit(emitName);
                callback(errors, success);
            });
        },
        clickLogScreenshot: function (id) {
            this.$emit('log-screenshot', id);
        },
        complete() {
            this.$emit('complete');
            this.$emit('close');
        },
        isPropertyRequired: function (property_required) {
            for (let index = 0; index < property_required.length; index++) {
                const element = property_required[index];
                if (!this.activeScript.variables[element]) {
                    var message = `Please provide a value for ${element} in the Variables table.`;
                    var flash = this.$dialog.alert(message, 'Validation Error');
                    return false;
                }
            }
            return true;
        },
        updateExchange(event) {
            this.$emit('update-exchange', event.target.value);
        },
        saveScript() {
            this.$emit('save');
        },
    },
    template: `
        <div class="goscript-wizard">
        <apck-wizard
            :disabled="isWizardDisabled"
            v-on:validate-step="handleStep"
            v-on:complete="complete"
        >
        <apck-wizard-pane title="Start">
            <div class="row">
                <div class="col-md-6" style="text-align: center;"><img src="/assets/images/wizard/wizard.svg" style="max-width: 300px; width:100%;"></div>
                <div class="col-md-6" style="padding-top: 15px;"><h1 style="margin-bottom: 15px;">Welcome to the GoScript Test Interface.</h1>
                <p style="margin-bottom: 15px;">
                This interactive wizard is designed to assist you in setting up your login script efficiently and effectively. From configuring your script credentials to validating the authentication, each step of this wizard is tailored to ensure you have a smooth and successful setup.</p>
                <p>Let's get started! Click "Next" to proceed to the credentials setup.
                </p>
                <div style="margin-top:40px;"></div>
                <apck-section
                    title="Scan hubs"
                    :collapsible="false"
                    :collapsed="false"
                >
                <p style="margin-bottom: 15px;">Please select the specific hub if needed.</p>
                <apck-field>
                    <select :value="wizardStatus.exchange" v-on:input="updateExchange">
                        <optgroup
                            v-if="exchanges.length > 0"
                            label="Internal hubs"
                        >
                            <option
                                v-for="exchange in exchanges"
                                :value="exchange.name">
                                    {{exchange.hub_id}}
                            </option>
                        </optgroup>
                        <optgroup label="External hubs">
                            <option value="">
                                Random external hub
                            </option>
                        </optgroup>
                    </select>
                </apck-field>
            </apck-section>
            </div>
            </div>
        </apck-wizard-pane>
        <apck-wizard-pane title="Credentials">
            <h1>Credentials</h1>
            <div class="goscript-wizard__description">
                To begin, please provide the following information to generate your login script automatically: Login Page URL, Username, and Password. Ensure you have the necessary credentials and access rights to proceed.
            </div>
            <apck-accordion title="Variables">
                <apck-goscript-variables
                    :active-script="activeScript"
                    :enable-credential-service="enableCredentialService"
                    :protected-keys="protectedKeys"
                />
            </apck-accordion>
            <apck-accordion
                v-if="enableCredentialService"
                title="Network Credentials"
            >
                <apck-goscript-network-credentials
                    :active-script="activeScript"
                />
            </apck-accordion>


        </apck-wizard-pane>

        <apck-wizard-pane title="Generate Auth">
            <h1>Generate Auth <i class="fa fa-bolt"></i></h1>
            <apck-progress-bar :percent="wizardStatus.progress"></apck-progress-bar>
            <div class="goscript-wizard__description" v-if="wizardStatus.running">
                <p class="goscript-wizard__description__title">{{wizardStatus.runningName}} <i v-if="wizardStatus.running" class="fa fa-spinner fa-spin"></i></p>
                <p>You can proceed to the next step once it succeeds.</p>
            </div>
            <div class="goscript-wizard__description" v-else>
                <p :class="['goscript-wizard__description__title', wizardStatus.generate ? 'text-positive' : 'text-negative']">{{wizardStatus.generateName}}</p>
                <p v-if="wizardStatus.generate">You can proceed to the next step and test your script.</p>
                <p v-else>Please verify your credentials and try again to continue with the wizard. Alternatively, you can close the wizard and use the GoScript Test Interface.</p>
            </div>
            <div v-if="wizardStatus.command === 'generate'">
                <h1>Logs</h1>
                <div class="modal-log" >
                    <apck-placeholder v-if="events.length === 0" title="No logs yet" description="Logs will appear here once available" />
                    <apck-log-console
                        :events="events"
                        @log-screenshot="clickLogScreenshot"
                    />
                </div>
            </div>
        </apck-wizard-pane>

        <apck-wizard-pane title="Test Script">
            <h1>Test Script  <i class="fa fa-play"></i></h1>
            <apck-progress-bar :percent="wizardStatus.progress"></apck-progress-bar>
            <div class="goscript-wizard__description" v-if="wizardStatus.running">
                <p class="goscript-wizard__description__title">{{wizardStatus.runningName}} <i v-if="wizardStatus.running" class="fa fa-spinner fa-spin"></i></p>
                <p>You can proceed to the next step once it succeeds.</p>
            </div>
            <div class="goscript-wizard__description" v-else>
                <p :class="['goscript-wizard__description__title', wizardStatus.test ? 'text-positive' : 'text-negative']">{{wizardStatus.testName}}</p>
                <p v-if="wizardStatus.test">You can proceed to the next step and set up your scope.</p>
                <p v-else>Please verify your credentials and try again to continue with the wizard. Alternatively, you can close the wizard and use the GoScript Test Interface. For more information, click here.</p>
            </div>
            <div v-if="wizardStatus.command === 'test'">
                <h1>Logs</h1>
                <div class="modal-log" >
                    <apck-placeholder v-if="events.length === 0" title="No logs yet" description="Logs will appear here once available" />
                    <apck-log-console
                        :events="events"
                        @log-screenshot="clickLogScreenshot"
                    />
                </div>
            </div>
        </apck-wizard-pane>
        <apck-wizard-pane title="Scope">
            <h1>Scope</h1>
            <p>
            Please select a scope.
            </p>
            <p>This list is for analysis purposes only, for accurate results it must correspond to the scope specified within the scan configuration and therefore must fall within your organisation's scope.</p>
            <apck-accordion title="Variables">
            <apck-goscript-scope
                v-model="activeScript.scope"
                confirmation-message="Are you sure you want to delete the scope host"
                confirmation-empty-message="Are you sure you want to delete the unnamed scope host?"
                confirmation-item="scope host"
                :selected-values.sync="activeScript.scope_selected_values"
            />
            </apck-accordion>

        </apck-wizard-pane>
        <apck-wizard-pane title="Analyse">
            <h1>Analyse auth <i class="fa fa-flask"></i></h1>
            <apck-progress-bar :percent="wizardStatus.progress"></apck-progress-bar>
            <div v-if="wizardStatus.running" class="goscript-wizard__description">
                <p class="goscript-wizard__description__title">{{wizardStatus.runningName}} <i v-if="wizardStatus.running" class="fa fa-spinner fa-spin"></i></p>
                <p>You can proceed to the next step once it succeeds.</p>
            </div>
            <div v-else class="goscript-wizard__description" >
                <p :class="['goscript-wizard__description__title', this.styleAnalyse]">{{wizardStatus.analyseName}}</p>
                <p v-if="isAnalyseSuccess">AppCheck was able to successfully execute the authentication flow, analyse the requests and responses in order to successfully apply the authentication to requests outside of the browser context, and identify an indicator target which can be used outside the browser context to confirm with the authentication state information is still valid.</p>
                <p v-if="isAnalyseWarning">Please verify your scope and try again. AppCheck was able to successfully execute the authentication flow; however, there was an issue with the analysis, which means the scanner may not be able to apply this authentication to requests and/or determine if the authentication has become invalid.</p>
                <p v-if="isAnalyseFail">Please verify your scope and try again to continue with the wizard. Alternatively, you can close the wizard and use the GoScript Test Interface.</p>
            </div>
            <div v-if="wizardStatus.command === 'analyse'">
                <h1>Logs</h1>
                <div class="modal-log" >
                    <apck-placeholder v-if="events.length === 0" title="No logs yet" description="Logs will appear here once available" />
                    <apck-log-console
                        :events="events"
                        @log-screenshot="clickLogScreenshot"
                    />
                </div>
            </div>
        </apck-wizard-pane>
        <apck-wizard-pane title="Result">
            <div class="row">
                <div v-if="wizardStatus.analyse" class="col-md-6" style="text-align: center;"><img src="/assets/images/wizard/wizard_success.svg" style="max-width: 300px; width:100%;"></div>
                <div v-else class="col-md-6" style="text-align: center;"><img src="/assets/images/wizard/wizard_fail.svg" style="max-width: 300px; width:100%;"></div>
                <div class="col-md-6" style="padding-top: 15px;"><h1 style="margin-bottom: 15px;">Result</h1>
                <div v-if="isAnalyseSuccess" style="margin-bottom: 15px;">
                    <p class="text-positive">Congratulations! You have successfully set up your GoScript and can now use it with the scanner.</p>
                </div>
                <div v-if="isAnalyseWarning">
                    <p class="text-warning">You have set up your GoScript, but Auth Mechanism NOT DETERMINED.</p>
                    <p>Please check your scope and run the auth analysis again before using the GoScript with the scan</p>
                </div>
                <div v-if="isAnalyseFail">
                    <p class="text-negative">You have set up your GoScript, but the authentication analysis FAILED..</p>
                    <p>Please check your scope and run the auth analysis again before using the GoScript with the scan</p>
                </div>
                <p>For additional information about the GoScript Test Interface, please click <a href="https://support.appcheck-ng.com/hc/en-us/articles/360011325597-A-Guide-to-GoScript" target="_blank">here</a></p>

                <div style="margin-top:40px;"></div>
                <apck-section
                    title="Save script"
                    :collapsible="false"
                    :collapsed="false"
                >
                    <p style="margin-bottom: 15px;">Please name the script for use within the scanner.</p>
                    <apck-field
                        style="margin-top: 10px;  margin-bottom: 10px;"
                    >
                        <input
                            type="text"
                            v-model="activeScript.name"
                            placeholder="Script Name"
                        />
                    </apck-field>
                    <apck-button title="Save" value="Save" icon="fa-save" class="btn-positive" :handler="saveScript" />
                </apck-section>
            </div>
            </div>

        </apck-wizard-pane>

        </apck-wizard>
        </div>
    `,
};
